<template>
  <div>
    <b-modal id="modalEditReplacementsInDocument" ref="modalEditReplacementsInDocument" :title="$t('Replacement')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" :disabled="editItem.id == 1" :label="$t('Key')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.key" aria-describedby="inputFeedbackName" :state="editItem.key.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.value"/>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditReplacementsInDocument')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      if (!this.editItem.key) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Key fields is invalid'), 'Error')
        return
      }

      let response = this.$store.dispatch('Settings/CREATE_REPLACEMENTS_IN_DOCUMENT', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_REPLACEMENTS_IN_DOCUMENT')
          this.$refs.modalEditReplacementsInDocument.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/documents/replacementsInDocument/editModal.vue